"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckHolder = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Transition = require("../animate/Transition");

var _iconConst = require("./iconConst");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckHolder = function CheckHolder(_ref) {
  var cssClass = _ref.cssClass,
      showUnchecked = _ref.showUnchecked,
      isChecked = _ref.isChecked;
  return _react.default.createElement(_Transition.Transition, _Transition.transitionConfigs.popConfig, isChecked && _react.default.createElement("div", {
    className: cssClass,
    key: isChecked
  }, _iconConst.CHECK_SELECTED), !isChecked && showUnchecked && _react.default.createElement("div", {
    className: cssClass,
    key: isChecked
  }, _iconConst.CIRCLE_EMPTY_ICON));
};

exports.CheckHolder = CheckHolder;
CheckHolder.defaultProps = {
  showUnchecked: false,
  isChecked: false
};
CheckHolder.propTypes = {
  cssClass: _propTypes.default.string.isRequired,
  showUnchecked: _propTypes.default.bool,
  isChecked: _propTypes.default.bool
};